import TwoFactorApi from '@/common/two-factor-api'

/**
 * Vuex Store Module for Two-Factor Authentication
 */
export const twoFactor = {
  state: {
    challengeData: null,
    setupData: null,
    status: null,
    isVerifying: false,
    isSettingUp: false
  },

  mutations: {
    SET_CHALLENGE_DATA(state, data) {
      state.challengeData = data
      if (data) {
        localStorage.setItem('2fa_challenge', JSON.stringify(data))
      } else {
        localStorage.removeItem('2fa_challenge')
      }
    },

    SET_SETUP_DATA(state, data) {
      state.setupData = data
    },

    SET_STATUS(state, status) {
      state.status = status
    },

    SET_VERIFYING(state, isVerifying) {
      state.isVerifying = isVerifying
    },

    SET_SETTING_UP(state, isSettingUp) {
      state.isSettingUp = isSettingUp
    },

    CLEAR_2FA_DATA(state) {
      state.challengeData = null
      state.setupData = null
      state.isVerifying = false
      state.isSettingUp = false
      localStorage.removeItem('2fa_challenge')
      localStorage.removeItem('2fa_setup_token')
      localStorage.removeItem('2fa_email')
    }
  },

  actions: {
    /**
     * Verify TOTP code
     */
    async verifyTotp({ commit }, { challengeId, code, rememberDevice }) {
      commit('SET_VERIFYING', true)
      try {
        const response = await TwoFactorApi.verifyTotp({
          challengeId,
          code,
          rememberDevice
        })
        commit('SET_VERIFYING', false)
        return response.data
      } catch (error) {
        commit('SET_VERIFYING', false)
        throw error
      }
    },

    /**
     * Setup TOTP
     */
    async setupTotp({ commit }) {
      commit('SET_SETTING_UP', true)
      try {
        const response = await TwoFactorApi.setupTotp()
        commit('SET_SETUP_DATA', response.data)
        commit('SET_SETTING_UP', false)
        return response.data
      } catch (error) {
        commit('SET_SETTING_UP', false)
        throw error
      }
    },

    /**
     * Enable 2FA
     */
    async enableTwoFactor({ commit }, code) {
      try {
        const response = await TwoFactorApi.enableTwoFactor(code)
        return response.data
      } catch (error) {
        throw error
      }
    },

    /**
     * Disable 2FA
     */
    async disableTwoFactor({ commit }, password) {
      try {
        const response = await TwoFactorApi.disableTwoFactor(password)
        commit('SET_STATUS', null)
        return response.data
      } catch (error) {
        throw error
      }
    },

    /**
     * Get 2FA status
     */
    async getStatus({ commit }) {
      try {
        const response = await TwoFactorApi.getStatus()
        commit('SET_STATUS', response.data)
        return response.data
      } catch (error) {
        throw error
      }
    },

    /**
     * Set challenge data (from login response)
     */
    setChallengeData({ commit }, data) {
      commit('SET_CHALLENGE_DATA', data)
    },

    /**
     * Clear all 2FA data
     */
    clear2FAData({ commit }) {
      commit('CLEAR_2FA_DATA')
    }
  },

  getters: {
    challengeData: state => state.challengeData,
    setupData: state => state.setupData,
    twoFactorStatus: state => state.status,
    isVerifying: state => state.isVerifying,
    isSettingUp: state => state.isSettingUp
  }
}
